import { Box, Grid } from '@mui/material'
import React, { useEffect, useMemo, useRef } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { FormData } from '../Provider/ProviderReport'
import { useReport } from '../ReportContext'
import ReportActions from './Actions'
import Report from './Report'
import ReportingHeader from './ReportingHeader'

const AccessorReport: React.FC = () => {
  const headerRef = useRef<HTMLDivElement>(null)
  const { response, isResponseFetching } = useReport()
  const formMethods = useForm<FormData>({
    shouldUnregister: false,
    mode: 'onChange',
  })

  const defaultValues = useMemo(
    () =>
      response?.items.reduce<FormData>(
        (prev, curr) => ({
          ...prev,
          [curr.requestItemId]: {
            id: curr.id,
            answer: curr.answer,
            selectedOptions: curr.selectedOptions,
            cannotAnswer: curr.cannotAnswer,
            estimatedAnswerAt: curr.estimatedAnswerAt,
            uploadReferences: [curr.uploadReferences].flat()[0],
            expiresAt: curr.expiresAt,
            planOnHaving: Boolean(curr.estimatedAnswerAt),
            answerStatus: curr.answerStatus,
            comment: curr.comment,
          },
        }),
        {},
      ),
    [response?.items],
  )

  useEffect(() => {
    if (!isResponseFetching) {
      formMethods.reset(defaultValues)
    }
  }, [defaultValues, isResponseFetching])

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <FormProvider {...formMethods}>
      <Box px={{ xs: 2, md: 5 }} mt={5} ref={headerRef}>
        <ReportingHeader />
      </Box>

      <Box bgcolor="grey.100" px={{ xs: 2, md: 5 }} py={5}>
        <Grid container spacing={5}>
          <Grid item xs={12} md={7} lg={8}>
            <Report />
          </Grid>

          <Grid item xs={12} md={5} lg={4}>
            <ReportActions />
          </Grid>
        </Grid>
      </Box>
    </FormProvider>
  )
}

export default AccessorReport
